export const HALL_PASS = 'Hall Pass' // no access to the course
export const REFUND = 'Refund' // no access to the course
export const TRANSFERRED = 'Transferred' // no access to the course
